import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import ltrRatings from "../../../../src/data/articles/cube-prospective-the-lord-of-the-rings-tales-of-middle-earth/ltr-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  ltrRatings,
  ProspectiveIntro,
  React
};